export enum KeyboardNavigationDirection {
  UP = 'up',
  DOWN = 'down',
  LEFT = 'left',
  RIGHT = 'right',
  FORWARD = 'forward',
  REVERSE = 'reverse',
}

export enum KeyboardNavigationInput {
  TITLE = 'TITLE',
  SUBTITLE = 'SUBTITLE',
  CELL = 'CELL',
}
